export function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

export function getCarrierAndPlan(cardState) {
    const carriers = cardState.predictions;
    if (carriers && carriers.length) {
        let prediction = carriers[0];
        let { carrier } = prediction;
        let plan = prediction.plans[0];

        if (cardState.selectedInsurance) {
            prediction = cardState.selectedInsurance;
            ({ carrier } = cardState.selectedInsurance);
            plan = cardState.selectedInsurance.plans[0];
            if (cardState.selectedPlan) {
                plan = cardState.selectedPlan;
            }
        }

        return {
            carrier,
            plan,
            prediction,
        };
    }

    return { };
}
